import type { ApiHandlerContract } from '../types/handlers/api';

/**
 * Generic API service class to be extended by specific service classes.
 */
export abstract class ApiService {
  constructor(protected api: ApiHandlerContract) {}
}

/**
 * A generic paginated response from a SparkLayer API.
 */
export type PaginatedResponse<T> = {
  data: T[];
  pagination: PaginationInformation;
};

/**
 * Pagination information included in paginated API responses.
 */
export type PaginationInformation = {
  total: number;
  per_page: number;
  current_page: number;
  total_pages: number;
};

export type { ApiHandlerContract } from '../types/handlers/api';
